export const convertFileToBlobUrl = (file: File): string | null => {
  return file ? URL.createObjectURL(new Blob([file], { type: file.type })) : null;
};

export function readFileAsText(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>): void => {
      const text = e.target?.result as string;
      resolve(text);
    };

    reader.onerror = (): void => {
      reject(new Error('Error reading file'));
    };

    reader.readAsText(file);
  });
}
